import { Route, Routes, Navigate } from 'react-router-dom';

// layouts
import { MainViewLayout } from 'layouts/main';
import { TypingLayout } from 'layouts/typing';


// pages
// import { Dashboard, CourseList, LoginPage, TypingTest, ExerciseList } from 'pages';
import {
  Dashboard,
  CourseList,
  LoginPage,
  EditorPage,
  ExerciseList,
  TypingTest,
  LoadingPage,
  GradesPage,
  ReportPage,
  PreviewPage
} from 'pages';

//toast wrapper
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useMediaQuery } from '@mui/material';
import ResultPage from 'components/ResultPage/ResultPage';
// import { ContentContainer } from 'components';
import PrivateRoute from './privateRoute';
import { useLocation } from 'react-router-dom';
// CKey-112: Route for session expiry
import SessionExpired from "./pages/SessionExpired/SessionExpired";
import RestartSession from "./pages/RestartSession/RestartSession";

function App() {
  const matches = useMediaQuery('(min-width:600px)');
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  return (
    <>
      <div className={isLoginPage ? 'login-background' : 'dashboard-background'}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
           { /* CKey-112: Route for session expiry */ }          
          <Route path="/session-expired" element={<SessionExpired />} />
          {/* Standalone report access */}
          <Route path="/report-access" element={<ReportPage />} />
           {/* Re-start session*/}
          <Route path="/restart-session" element={<RestartSession />} />

          <Route element={<PrivateRoute />}>
            <Route path="/" element={<MainViewLayout />}>
              <Route index element={<Navigate replace to="dashboard" />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="courses" element={<CourseList />} />
              <Route path="grades" element={<GradesPage />} />
              <Route path="reports" element={<ReportPage />} />
              <Route path="courses/:id" element={<CourseList />} />
              <Route path="courses/:id/:type" element={<ExerciseList />} />
              <Route path="/result" element={<ResultPage />} />
            </Route>

            <Route path="/" element={<TypingLayout />}>
              <Route path="courses/editor/:id" element={<EditorPage />} />
              <Route path="courses/typing/:id" element={<TypingTest />} />
            </Route>
          </Route>

          <Route path="/loading/:id/:name/:email/:exerciseName" element={<LoadingPage />} />
          <Route path="/loading" element={<PreviewPage />} />

          {/* 404 */}
          <Route path="*" element={<h4>404, Not found</h4>} />
        </Routes>

        <ToastContainer
          position="bottom-left"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          draggable
          pauseOnHover
          style={{ marginLeft: matches ? '50px' : 0 }}
        />
      </div>
    </>
  );
}

export default App;
